import { render, staticRenderFns } from "./WagnerCastilho.vue?vue&type=template&id=601652cc"
import script from "./WagnerCastilho.vue?vue&type=script&lang=js"
export * from "./WagnerCastilho.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports